import * as Sentry from '@sentry/browser'
import { BASE_URL, X_API_KEY } from './api'

export interface UserData {
  firstname: string
  lastname: string
  birthday: string
  nickname: string
  email: string
  password: string
  phone: string
  tva: string
  address: {
    street: string
    number: string
    city: string
    zip_code: number
  }
  status: string[]
}

export async function registerUser(user: UserData) {
  try {
    const response = await fetch(`${BASE_URL}/auth/register`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': X_API_KEY,
      },
      body: JSON.stringify(user),
    })

    const data = await response.json()

    if (!response.ok || (data.errors && data.errors.length > 0)) {
      const errorMessage =
        data.message ||
        (data.errors && data.errors[0].message) ||
        'Registration failed'
      Sentry.captureException(new Error(errorMessage), {
        extra: {
          action: 'registerUser',
          user,
          response: data,
          statusCode: response.status,
          timestamp: new Date().toISOString(),
        },
        tags: {
          type: 'api_error',
          method: 'registerUser',
        },
      })
      return { error: errorMessage }
    }

    return {
      success: data.message || 'Félicitations, vous pouvez vous connecter',
    }
  } catch (error) {
    Sentry.captureException(error, {
      extra: {
        action: 'registerUser',
        user,
        timestamp: new Date().toISOString(),
      },
      tags: {
        type: 'network_error',
        method: 'registerUser',
      },
    })
    return { error: "Une erreur s'est produite" }
  }
}

export const checkEmailExists = async (email: string): Promise<boolean> => {
  try {
    const response = await fetch(`/api/check-email?email=${email}`, {
      headers: {
        'x-api-key': X_API_KEY,
      },
    })
    const data = await response.json()
    return data.exists
  } catch (error) {
    Sentry.captureException(error, {
      extra: {
        action: 'checkEmailExists',
        email,
        timestamp: new Date().toISOString(),
      },
      tags: {
        type: 'api_error',
        method: 'checkEmailExists',
      },
    })
    throw error
  }
}
